var _rect, _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTwitchNotConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0474 15.8457L20.0713 18.7335H15.3964L12.8461 21.2079V18.7335H9.02072V6.7719H23.0474V15.8457ZM7.31993 5.12207L6.46997 8.42195V23.2702H10.2958V25.333H12.4204L14.5462 23.2702H17.9461L24.7466 16.6718V5.12207H7.31993Z",
    fill: "#6441A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6968 15.0293H15.3939V10.0189H13.6968V15.0293ZM18.3635 15.0293H20.0606V10.0189H18.3635V15.0293Z",
    fill: "#6441A5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 6,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30C22.2385 30 20 27.7615 20 25C20 22.2385 22.2385 20 25 20C27.7615 20 30 22.2385 30 25C30 27.7615 27.7615 30 25 30ZM25 24.293L23.586 22.8785L22.8785 23.586L24.293 25L22.8785 26.414L23.586 27.1215L25 25.707L26.414 27.1215L27.1215 26.414L25.707 25L27.1215 23.586L26.414 22.8785L25 24.293Z",
    fill: "#FF6633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTwitchNotConnected);
export default __webpack_public_path__ + "static/media/logo_twitch_not_connected.10ef84935917da3cb8446aa04df43056.svg";
export { ForwardRef as ReactComponent };